<script>
// Componente para apresentar a carteira do cliente em modal
import CarteiraAnalise from '@views/carteira-analise'
import Vue from 'vue'
import Title from '@components/section-title'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'

export default {
  components: { CarteiraAnalise, Title },
  props: {
    // Controle de eventos baseado na left-bar
    busLeft: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      // Controle de eventos para o componente da carteira
      bus: new Vue(),
      // Controle de eventos para o componente de modal
      busModal: new Vue(),
      // Eventos para carregando o processo de imprimir
      loadingImprimir: false,
      cliente: null,
    }
  },
  created() {
    GlobalBus.$on(MODAL.MODAL_WALLET_ANALYSIS, this.open)
    this.bus.$on('set-loading-imprimir', (v) => {
      this.loadingImprimir = v
    })
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.MODAL_WALLET_ANALYSIS, this.open)
  },
  methods: {
    /**
     * Abrir modal
     */
    open(cliente) {
      this.cliente = cliente
      this.selectClient(cliente)
      this.busModal.$emit('dialog', true)

      this.$nextTick(() => {
        GlobalBus.$emit('changeClient')
      })
    },
    selectClient(cliente) {
      if (!cliente || !cliente.id) return
      this.$store.dispatch('user/addSearchClient', {
        id: cliente.id,
        id_cadastro_cliente: cliente.id_cadastro_cliente,
        name: cliente.nome_cliente || cliente.name || '',
      })
    },
    /**
     * Imprimit análise
     */
    imprimir() {
      this.bus.$emit('imprimir-analise-portfolio', true)
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="96%">
    <Title
      title="Análise de portfólio"
      :subtitle="cliente ? cliente.name : ''"
    />
    <CarteiraAnalise
      :bus-left="busLeft"
      :bus="bus"
      :show-actions="false"
      :cliente-modal="cliente"
    />

    <template v-slot:actions>
      <v-spacer />
      <!-- <BaseButton underlined>
        Voltar
      </BaseButton> -->
      <!-- <BaseButton dark>
        Enviar
      </BaseButton> -->
      <!-- <BaseButton primary @click="imprimir" :loading="loadingImprimir">
        Imprimir
      </BaseButton> -->
      <v-spacer />
    </template>
  </BaseModal>
</template>


